/*
 * Official horse icon (client asset, self-hosted at /images/brand/horse-icon.png).
 * Rendered through a CSS mask so it inherits `currentColor` like a lucide icon —
 * recolorable (black/white/gray) and crisp at every size.
 * Drop-in replacement for lucide icons: accepts className + any span props.
 */
const MASK = {
  backgroundColor: "currentColor",
  WebkitMask: "url(/images/brand/horse-icon.png) no-repeat center / contain",
  mask: "url(/images/brand/horse-icon.png) no-repeat center / contain",
};

export const HorseIcon = ({ className = "w-4 h-4", ...props }) => (
  <span aria-hidden="true" {...props} style={MASK} className={`inline-block shrink-0 ${className}`} />
);
